<template>
    <div class="carousel" @touchstart="start" @touchmove="move" @touchend="end">
        <div class="carousel-container" :style="currentPosition">
            <div class="carousel-content" :style="photo" :key="index" v-for="(photo, index) in photos">
            </div>
        </div>

        <legends class="legend" v-model="currentIndex" :total="length" ></legends>
    </div>
</template>
<style scoped>
    .carousel {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 100%;
        user-select: none;
    }
    .carousel-container {
        position: absolute;
        width: 100%;
        height: 100%;
        transition-property: transform;
        transition-duration:0.2s;
        transition-timing-function: ease-out;
    }
    .carousel-content {
        position: absolute;
        width: 100%;
        top: 0;
        bottom: 60px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
    }
    .carousel .legend {
        position: absolute;
        width: 260px;
        left : calc((100% - 260px) / 2);
        bottom: 0;
    }
</style>
<script>
import legends from './legends'

const handler = event => event.preventDefault()

export default {
    name: 'oasis-carousel',
    props: { index: {}, listData: Array },
    components: { legends },
    data () {
        return {
            width: 0,
            currentIndex: 0,
            moveX: 0,
            startX: 0
        }
    },

    mounted () {
        this.width = this.$el.offsetWidth
        window.removeEventListener('touchmove', handler)
        window.addEventListener('touchmove', handler)
    },

    beforeDestroy () {
        window.removeEventListener('touchmove', handler)
    },

    methods: {
        start (e) {
            this.startX = e.targetTouches[0].pageX
        },
        move (e) {
            this.moveX = e.targetTouches[0].pageX - this.startX
        },
        end (e) {
            if (this.moveX > 80) {
                this.currentIndex = Math.max(this.currentIndex - 1, 0)
            } else if (this.moveX < -80) {
                this.currentIndex = Math.min(this.currentIndex + 1, this.length - 1)
            }

            this.startX = 0
            this.moveX = 0
        }
    },

    computed: {
        photos () {
            if (this.index >= 0) {
                return this.listData[this.index].photos.map((d, i) => {
                    return {
                        left: this.width * i + 'px',
                        'background-image': 'url(' + d + ')'
                    }
                })
            }
            return []
        },

        length () {
            return this.photos.length
        },

        currentPosition () {
            if (!this.width) {
                return {}
            }
            const position = -this.currentIndex * this.width
            if (Math.abs(this.moveX) > 10) {
                return {
                    transform: 'translate3d(' + (position + this.moveX) + 'px,0,0)',
                    'transition-duration': '0s'
                }
            }
            return {
                transform: 'translate3d(' + position + 'px, 0,0)'
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/carousel/src/main.vue